(ns app.front.view.escrow.util
  (:require [app.domain.fee.model :as fee-model]
            [app.domain.workspace.model :as workspace-model]
            [app.front.view.workspace.util :as ws-util]))

(defn transaction->workspace [transaction]
  (-> transaction
      :escrow-transaction/bill
      fee-model/bill-workspace))

(defn transaction->workspace-id [transaction]
  (-> transaction
      transaction->workspace
      workspace-model/case-id))

(defn transaction->workspace-link [transaction]
  (when-some [ws (transaction->workspace transaction)]
    (ws-util/workspace-or-resume-application-href ws)))

(defn transaction->workspace-link-description [transaction]
  (some-> transaction
          transaction->workspace
          ws-util/workspace-link-description))
